var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "sweet-modal",
        {
          ref: "modal",
          attrs: {
            "overlay-theme": "dark",
            blocking: "",
            "enable-mobile-fullscreen": false
          }
        },
        [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("message.line_contact.detail"))
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://line.me/R/ti/p/%40hnk7011n",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  attrs: {
                    height: "38",
                    alt: "Line BeNeat",
                    src: "/static/img/btn-line.png"
                  }
                })
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94e8e75a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e8e75a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/LineContactModal.vue
// module id = 1406
// module chunks = 0